var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 16C19.3125 17.5532 18.0532 18.8125 16.5 18.8125C14.9468 18.8125 13.6875 17.5532 13.6875 16C13.6875 14.4468 14.9468 13.1875 16.5 13.1875C18.0532 13.1875 19.3125 14.4468 19.3125 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 7.5H11.75C9.68213 7.5 8 9.18213 8 11.25V20.75C8 22.8179 9.68213 24.5 11.75 24.5H21.25C23.3179 24.5 25 22.8179 25 20.75V11.25C25 9.18213 23.3179 7.5 21.25 7.5ZM16.5 20.6875C13.9153 20.6875 11.8125 18.5847 11.8125 16C11.8125 13.4153 13.9153 11.3125 16.5 11.3125C19.0847 11.3125 21.1875 13.4153 21.1875 16C21.1875 18.5847 19.0847 20.6875 16.5 20.6875ZM21.875 11.5625C21.3572 11.5625 20.9375 11.1428 20.9375 10.625C20.9375 10.1072 21.3572 9.6875 21.875 9.6875C22.3928 9.6875 22.8125 10.1072 22.8125 10.625C22.8125 11.1428 22.3928 11.5625 21.875 11.5625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 0H8.9375C4.28516 0 0.5 3.78516 0.5 8.4375V23.5625C0.5 28.2148 4.28516 32 8.9375 32H24.0625C28.7148 32 32.5 28.2148 32.5 23.5625V8.4375C32.5 3.78516 28.7148 0 24.0625 0ZM26.875 20.75C26.875 23.8516 24.3516 26.375 21.25 26.375H11.75C8.64844 26.375 6.125 23.8516 6.125 20.75V11.25C6.125 8.14844 8.64844 5.625 11.75 5.625H21.25C24.3516 5.625 26.875 8.14844 26.875 11.25V20.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramSocial);
export default __webpack_public_path__ + "static/media/instagram-social.cd50a7f8f9909bf751f7eab53a8ab4a5.svg";
export { ForwardRef as ReactComponent };